<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row mt-4">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">
                {{ clinicId ? "Edit" : "Add" }} Clinic
              </h3>
            </div>
            <v-stepper v-model="e1" light>
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1" editable
                  >Clinic Details</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step  
                :complete="e1 > 2" 
                step="2"
                @click="validateUpdate"
                :editable="clinicId ? true : false"
                  >Clinic Image</v-stepper-step
                >
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content class="v-form-body" step="1">
                  <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    enctype="multipart/form-data"
                  >
                    <v-row>
                      <v-col cols="6">
                        <label class="form-control-label">
                          Name
                          <span class="red--text">*</span>
                        </label>
                        <ValidationProvider
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="clinic.name"
                            placeholder="Enter Clinic Name"
                            :error-messages="errors"
                            solo
                            :rules="[(v) => !!v || 'Name is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                          />
                        </ValidationProvider>
                      </v-col>

                      <v-col cols="6">
                        <v-card-title class="pt-8 pr-0 justify-start">
                          <h4>Active</h4>
                          <v-switch
                            class="pl-4 pt-3 mt-0"
                            v-model="clinic.isActive"
                            flat:label="Yes"
                            inset
                          ></v-switch>
                        </v-card-title>
                      </v-col>

                      <v-col cols="6">
                        <label class="form-control-label">
                          Street Address
                          <span class="red--text">*</span>
                        </label>
                        <v-text-field
                          v-model="clinic.streetAddress"
                          solo
                          label="Enter Street Address"
                          :rules="[(v) => !!v || 'Street Address is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <label class="form-control-label">
                          Country
                          <span class="red--text">*</span>
                        </label>
                        <ValidationProvider
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="clinic.country"
                            solo
                            :error-messages="errors"
                            label="country"
                            :rules="[(v) => !!v || 'Country is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                          />
                        </ValidationProvider>
                      </v-col>

                      <v-col cols="6">
                        <label class="form-control-label">
                          City
                          <span class="red--text">*</span>
                        </label>
                        <ValidationProvider
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="clinic.city"
                            solo
                            label="Enter City"
                            :error-messages="errors"
                            :rules="[(v) => !!v || 'City is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                          />
                        </ValidationProvider>
                      </v-col>

                      <v-col cols="6">
                        <label class="form-control-label">
                          Postcode
                          <span class="red--text">*</span>
                        </label>
                        <v-text-field
                          v-model="clinic.postcode"
                          solo
                          label="Enter Postcode"
                          :rules="postcodeRules"
                        >
                        </v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <label class="form-control-label">
                          Phone Number
                          <span class="red--text">*</span>
                        </label>
                        <v-text-field
                          v-model="clinic.phoneNumber"
                          solo
                          label="Enter Phone Number"
                          :rules="validatePhoneNumber"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <label class="form-control-label">
                          Website
                        </label>
                        <v-text-field
                          v-model="clinic.webAddress"
                          solo
                          label="Enter Website"
                          :rules="validateUrl"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <label class="form-control-label">
                          Email Address
                          <span class="red--text">*</span>
                        </label>
                        <v-text-field
                          v-model="clinic.email"
                          solo
                          label="Enter Email Address"
                          :rules="emailRules"
                        ></v-text-field>
                      </v-col>

                        <!-- <v-col cols="6">
                          <v-card-title class="pt-8 pr-0 justify-start">
                            <h4>Favourite?</h4>
                            <v-switch class="pl-4 pt-3 mt-0" v-model="clinic.isFavourite" flat:label="Yes" inset></v-switch>
                          </v-card-title>
                        </v-col> -->

                      <v-col cols="12">
                        <label class="form-control-label">
                          About
                        </label>
                        <quill-editor
                          v-model="clinic.description"
                          ref="myQuillEditor"
                          :options="editorOption"
                        ></quill-editor>
                      </v-col>

                      <v-col class="text-right" cols="12">
                        <v-btn
                          color="#989898"
                          class="mr-4 white--text"
                          @click="cancel"
                          >Cancel</v-btn
                        >
                        <v-btn
                          v-if="!clinicId"
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="validateSave"
                          >Next</v-btn
                        >
                        <v-btn
                          v-if="clinicId"
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="validateUpdate"
                          >Next</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>

                <v-stepper-content class="v-form-body" step="2">
                  <v-row>
                    <v-col
                      :class="$vuetify.breakpoint.mdAndUp ? 'col-6' : 'col-12'"
                      class="pa-5"
                    >
                      <v-card>
                        <v-card-title>
                          <span class="Subtitle 1">Upload Clinic Image</span>
                        </v-card-title>
                        <v-card-text>
                          <vue-dropzone
                            class="vue-dropzone-box"
                            ref="myVueDropzone"
                            id="dropzone"
                            :destroyDropzone="false"
                            :options="dropzoneOptions"
                            @vdropzone-sending="beforecomplete"
                            @vdropzone-success="aftercomplete"
                            @vdropzone-mounted="uploadedImage"
                            @vdropzone-removed-file="removeFile"
                            :useCustomSlot="true"
                            :useCustomDropzoneOptions="true"
                          >
                            <div class="dropzone-custom-content">
                              <img src="@/assets/images/ImageUpload.svg" />
                              <h3 class="font-weight-light ma-0">
                                Drag and drop here to upload
                              </h3>
                              <h3 class="font-weight-light ma-0">Or</h3>
                              <h3 class="dropzone-custom-title">Browse</h3>
                            </div>
                          </vue-dropzone>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-col class="text-right" cols="12">
                    <v-btn
                      color="#989898"
                      class="mr-4 white--text"
                      @click="cancel"
                      >Cancel</v-btn
                    >
                    <v-btn
                      :disabled="!valid"
                      color="#344452"
                      class="white--text"
                      :loading="loading"
                      @click="save"
                      >{{ clinicId ? "Update" : "Save" }}</v-btn
                    >
                  </v-col>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import CommonSection from "@/components/CommonHeader";
import { MediaService, ClinicService } from "@/services";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import {
  MEDIATYPE_THUMBNAIL,
  CLINIC_IMAGE_WIDTH,
  CLINIC_IMAGE_HEIGHT,
} from "@/constants";
import { ImageValidateMixin } from "@/mixins";
import { ValidationProvider } from "vee-validate";

export default {
  name: "AddClinic",
  components: {
    CommonSection,
    quillEditor,
    ValidationProvider,
    vueDropzone: vue2Dropzone,
  },
  mixins: [ImageValidateMixin],
  data() {
    var self = this;
    return {
      e1: 1,
      loading: false,
      open: ["public"],
      valid: true,
      clinicId: null,
      status: false,
      media: [],
      clinic: {
        name: null,
        isActive: false,
        streetAddress: null,
        country: null,
        city: null,
        postcode: null,
        phoneNumber: null,
        webAddress: "",
        email: null,
        description: null,
        // isFavourite: false,
      },
      validateUrl: [
        (v) => v && !!v.trim() || 'Field cannot be blank',
        (v) =>
          !v ||
          /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/.test(
            v
          ) ||
          "Your url link is not valid.",
      ],
      validatePhoneNumber: [
        (v) => !!v || "Phone number is required!",
        (v) => v && !!v.trim() || 'Field cannot be blank',
        (v) =>
          /^(\+\d{1,3}[- ]?)?\d{10}$/.test(v) || "Phone number must be valid",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required!",
        (v) => v && !!v.trim() || 'Field cannot be blank',
        (v) =>
          /.+@.+\..+/.test(v) || "You have entered an invalid e-mail address.",
      ],
      postcodeRules: [
        (v) => !!v || 'Postcode is required!',
        (v) => v && !!v.trim() || 'Field cannot be blank',
        (v) =>
          /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/.test(
            v
          ) || "This Field must contain valid uk format postcode",
      ],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_SERVERURL}media`,
        chunking: true,
        addRemoveLinks: true,
        autoProcessQueue: true,
        maxFilesize: 2, // MB
        thumbnailWidth: 300,
        maxFiles: 1,
        dictFileTooBig:"File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
        headers: {
          Authorization: `Bearer ${store.state.user.token}`,
        },
        acceptedFiles: "image/*",
        init() {
           this.on("maxfilesexceeded", function(file) {
              this.removeAllFiles();
              this.addFile(file);
           });
           this.on("addedfile", file => {
            if (file.size > 1024 * 1024 * 2) {
              // not more than 2mb
              this.removeFile(file);
            }
          });
          this.on("thumbnail", (file) => {
            self.validateBannerDimension(
              file,
              CLINIC_IMAGE_WIDTH,
              CLINIC_IMAGE_HEIGHT
            );
          });
        },
        accept(file, done) {
          self.showError(file, CLINIC_IMAGE_WIDTH, CLINIC_IMAGE_HEIGHT, done);
        },
      },
      editorOption: {
        theme: "snow",
      },
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id !== "create") {
        this.clinicId = this.$route.params.id
        await this.getClinicData();
        await this.uploadedImage();
      }
    },
    async getClinicData() {
      let clinic;
      if(this.$route.params.id === "create")      
       clinic = await ClinicService.getClinic(this.clinicId);
      else{
         clinic = await ClinicService.getClinic(this.$route.params.id);
      }
      this.clinic.name = clinic.data.data[0].name;
      this.clinic.streetAddress = clinic.data.data[0].streetAddress;
      this.clinic.country = clinic.data.data[0].country;
      this.clinic.city = clinic.data.data[0].city;
      this.clinic.postcode = clinic.data.data[0].postcode;
      this.clinic.phoneNumber = clinic.data.data[0].phoneNumber;
      this.clinic.webAddress = clinic.data.data[0].webAddress;
      this.clinic.isActive = clinic.data.data[0].isActive;
      this.clinic.email = clinic.data.data[0].email;
      this.clinic.description = clinic.data.data[0].description;
      this.media = clinic.data.data[0].media;
      // this.clinic.isFavourite = clinic.data.data[0].isFavourite;
    },
    beforecomplete(file, xhr, formData) {
      formData.append("mediaType", "image");
      formData.append("moduleType", "education/clinic");
      formData.append("mediaSubType", "file");
      formData.append("imageType", MEDIATYPE_THUMBNAIL);
      formData.append("moduleId", this.clinicId);
    },
    aftercomplete() {
      this.$store.dispatch(
        "user/setSnack",
        "Clinic Image uploaded successfully!"
      );
      this.getClinicData();
      this.$store.dispatch("user/setType", "info");
    },
    uploadedImage() {
      if (this.media && this.media.length > 0) {
        this.media.filter((media) => {
          if (media.mediaType == "image") {
            var file = {
              size: media.size,
              name: media.name,
              type: media.type,
            };
            this.$refs.myVueDropzone.manuallyAddFile(file, media.url);
          }
        });
      }
    },
    removeFile(file) {
      if (file.size > 1024 * 1024 * 2) {
        this.$store.dispatch(
          "user/setSnack",
          "Upto 2MB File size is allowed"
        );
        this.$store.dispatch("user/setType", "error");
      }
      this.deletePicture(file);
    },
    async deletePicture(file) {
      try {
        if (file) {
          let mediaId = this.media.filter((media) => {
            if (media.mediaType == "image" && media.name == file.name) {
              return media._id;
            }
          });
          if (mediaId.length > 0) {
            const response = await MediaService.deleteMedia({
              id: mediaId[0]._id,
              body: {
                moduleType: "education/clinic",
                moduleId: this.clinicId,
              },
            });
            this.getClinicData();
            if (response) {
              this.$store.dispatch(
                "user/setSnack",
                "Clinic image deleted successfully!"
              );
              this.$store.dispatch("user/setType", "info");
            }
          }
        }
      } catch (error) {
        this.$store.dispatch("user/setSnack", error);
        this.$store.dispatch("user/setType", "error");
      }
    },
    cancel() {
      this.$router.push("/clinic");
    },
    async validateSave() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await ClinicService.createClinic(this.clinic);
          this.loading = false;
          if (response) {
            this.e1 = 2;
            this.clinicId = response.data.id;
            this.$store.dispatch("user/setSnack", "Clinic added successfully!");
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async validateUpdate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await ClinicService.updateClinic({
            id: this.clinicId,
            object: this.clinic,
          });
          this.loading = false;
          if (response) {
            this.e1 = 2;
            this.clinicId = response.data.id;
            this.$store.dispatch(
              "user/setSnack",
              `Clinic updated successfully!`
            );
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          this.loading = false;
          this.$router.push("/clinic");
          this.$store.dispatch(
            "user/setSnack",
            `Clinic ${this.clinicId ? "updated" : "added"} successfully!`
          );
          this.$store.dispatch("user/setType", "info");
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.main-content .navbar-top {
  display: none !important;
}
</style>
